import { render, staticRenderFns } from "./CharityRunCheckin.vue?vue&type=template&id=12974ae2&scoped=true"
import script from "./CharityRunCheckin.vue?vue&type=script&lang=js"
export * from "./CharityRunCheckin.vue?vue&type=script&lang=js"
import style0 from "./CharityRunCheckin.vue?vue&type=style&index=0&id=12974ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12974ae2",
  null
  
)

export default component.exports